import React from "react";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Modal from "reboron/DropModal";

import { AuthenticationType, getAuthenticationType } from "../../constants/AuthenticationType";
import { SIGNED_HEADERS, ACCEES_KEY, SECRET_KEY } from "../../constants/AuthenticationTypeHMAC";

import { PageHeader } from "../../components/PageHeader";

import * as connectionActions from "../../actions/connectionActions";
import * as globalParamAction from "../../actions/globalParamActions";
import * as paymentAction from "../../actions/paymentActions";

import FlowTable from "../../components/FlowTable";

import { formatDate } from "../../helpers/utils";
import { CONNECTION_INTERVAL_TIME_IN_MILLIS } from "../../constants/api";
import { getAuthToken } from "../../helpers/storage";
import { checkUserActivity, Activity, UserRole, checkUserRole, getUserRoles } from "../../helpers/userActivity";
import { BACKOFFICE_APPLICATION, PROXY_SERVER } from "../../constants/api";
import ConnectionFilter from "../../components/ConnectionFilter";
import { getConnectionType } from "../../constants/ConnectionType";
import RestaurantPayments from "../../components/RestaurantPayments";
import { computeSignature } from "../../helpers/authentication/authenticationHMAC";

// Individual styles for the modal, modal content, and backdrop
const modalStyle = {
  //transform: 'rotate(45deg) translateX(-50%)',
  //width: '80%'
  width: '800px'
};

const backdropStyle = {
  // backgroundColor: 'red',
};

const contentStyle = {
  // backgroundColor: 'blue',
  height: '100%',
};

// Set the name of the hidden property and the change event for visibility
let hidden, visibilityChange;
if (typeof document.hidden !== "undefined") {
  // Opera 12.10 and Firefox 18 and later support
  hidden = "hidden";
  visibilityChange = "visibilitychange";
} else if (typeof document.msHidden !== "undefined") {
  hidden = "msHidden";
  visibilityChange = "msvisibilitychange";
} else if (typeof document.webkitHidden !== "undefined") {
  hidden = "webkitHidden";
  visibilityChange = "webkitvisibilitychange";
}

/**
 * Komponent zawierający kolekcję dostępnych połączeń.
 * Połączenia są odświeżane co 1000ms - 1s, i tylko jeśli tab przeglądarki jest widoczny.
 * 
 * Widok różni się w zależności od posiadanych ról zalogowanej osoby.
 * 
 * Dla roli ADMIN - pojawia się filtr z dostępnymi typami połączeń {@link ConnectionType}, 
 * z domyślnie zaznaczonym {@link ConnectionType.YES_LICENSE_CODE__YES_VERSION} - czyli połączenie oryginalne(pasuje kod licencji z kodem sprzętowym) z aktualną wersją
 * 
 * Dla roli MANAGER/SERWIS - filtr się nie pojawia, i widocznę są wszystkie połączenia otrzymane z serwera.
 * 
 * Dodatkowo, w tabelce zawierającej połączenia, mamy specjalą właściwość userRole - która, determinuje dla których ról dana kolumna jest widoczna. 
 * 
 */
class Connections extends React.Component {
  state = {
    //zawiera widoczność tabów
    actions: [],
    //domyśnie rozwinięte wiersze połączeń {index:true}, np {0, true}- oznacza rozwinięcie pierwszero wiersza w tabelce
    //na ten moment wspieramy rozszerzalność tylko jednego wiersza na raz
    expandedRows: {},
    //wybrany wiersz
    selectedRow: {}
  };


  componentDidMount() {

    //rejestracja listenera, który obsługuję widoczność taba w przeglądarce
    // Warn if the browser doesn't support addEventListener or the Page Visibility API
    if (
      typeof document.addEventListener === "undefined" ||
      hidden === undefined
    ) {
      //jesli nie jest wspierane Visibility API - nic nie robimy - dziala po staremu czyli w tle pytamy sie o połączenia
      console.log(
        "This app requires a browser, such as Google Chrome or Firefox, that supports the Page Visibility API."
      );
    } else {
      //jesli wspierane jest Visibility API - dodajemy listenera, ktory bedzie nas informowal o widocznosci taba
      document.addEventListener(
        visibilityChange,
        this.handleVisibilityChange,
        false
      );
    }

    //pobieramy platnosci przedawnione, aby odpowiednio pokolorowac przycisk Platnosci
    this.props.onFetchOverduePayments();

    //pobieramy parametry globalne niezbędne dla filtra DEMO
    //tylko dla admina, inni nie maja praw ani potrzeby
    const hasListGlobalParamsActivity = checkUserActivity(this.props.authenticatedUser, Activity.LIST_GLOBAL_PARAMS);
    if (hasListGlobalParamsActivity) {
      this.props.onFetchGlobalParams();
    }

    //uruchamiamy pętlę pytająca się o połączenia
    this.interval = setInterval(() => {
      //ladowanie danych do tabelki
      this.props.onFetch(() => {
        //nic nie robimy
      });
    }, CONNECTION_INTERVAL_TIME_IN_MILLIS);
  }

  /**
   * Metoda, która w zależności od widoczności taba - uruchamia bądź stopuje timer w którym pytamy sie o połączenia
   */
  handleVisibilityChange = () => {
    if (document[hidden]) {
      //tab jest niewidoczny

      this.setState({ actions: [...this.state.actions, "hide"] });

      //czyscimy timer
      clearInterval(this.interval);
    } else {
      //tab jest widoczny

      this.setState({ actions: [...this.state.actions, "show"] });

      //startujemy timer
      this.interval = setInterval(() => {
        //ladowanie danych do tabelki
        this.props.onFetch(() => {
          //nic nie robimy
        });
      }, CONNECTION_INTERVAL_TIME_IN_MILLIS);
    }
  };

  componentWillUnmount() {
    //czyszczenie listenera, który obsługuję widoczność taba w przeglądarce
    document.removeEventListener(visibilityChange, this.handleVisibilityChange);
    //czyszczenie timera, który pyta się o połączenia
    clearInterval(this.interval);
  }

  /**
  * Pokazuje modal
  */
  showModal() {
    this.refs.modal.show();
  }

  /**
   * Chowa modal
   */
  hideModal = () => {
    this.refs.modal.hide();
  };

  /**
   * Kolumny do tabelki
   * 
   * Dodana jest specjala właściwość userRole - która, determinuje dla których ról dana kolumna jest widoczna. 
   * 
   */
  tableColumns = [

    /*{
      Header: this.props.formatMessage("connection.id"),
      accessor: "id",
      headerStyle: { whiteSpace: "unset" },
      style: { whiteSpace: "unset", textAlign: "right" },
      maxWidth: 80,
      userRole: [UserRole.ROLE_ADMIN]
    },*/
    {
      Header: this.props.formatMessage("connection.companyId"),
      accessor: "companyId",
      headerStyle: { whiteSpace: "unset" },
      style: { whiteSpace: "unset", textAlign: "right" },
      maxWidth: 80,
      userRole: [UserRole.ROLE_ADMIN, UserRole.ROLE_SERVICE, UserRole.ROLE_MANAGER]
    },
    {
      Header: this.props.formatMessage("connection.companyName"),
      accessor: "companyName",
      headerStyle: { whiteSpace: "unset" },
      style: { whiteSpace: "unset" },
      minWidth: 200,
      maxWidth: 300,
      userRole: [UserRole.ROLE_SERVICE, UserRole.ROLE_MANAGER]
    },
    {
      Header: this.props.formatMessage("connection.companyDescription"),
      accessor: "companyDescription",
      headerStyle: { whiteSpace: "unset" },
      style: { whiteSpace: "unset" },
      minWidth: 200,
      maxWidth: 300,
      userRole: [UserRole.ROLE_SERVICE, UserRole.ROLE_MANAGER]
    },
    {
      Header: this.props.formatMessage("connection.companyName") + "/" + this.props.formatMessage("connection.companyDescription"),
      accessor: "companyName",
      headerStyle: { whiteSpace: "unset" },
      style: { whiteSpace: "unset" },
      maxWidth: 300,
      minWidth: 200,
      Cell: row => {
        return (
          <div>
            {row.original.companyName}
            <br />
            {row.original.companyDescription}
          </div>
        )
      },
      userRole: [UserRole.ROLE_ADMIN]
    },
    {
      Header: this.props.formatMessage("connection.companyAddress"),
      accessor: "companyAddress",
      headerStyle: { whiteSpace: "unset" },
      style: { whiteSpace: "unset" },
      minWidth: 200,
      maxWidth: 300,
      userRole: [UserRole.ROLE_SERVICE, UserRole.ROLE_MANAGER]
    },
    {
      Header: this.props.formatMessage("connection.licenseClientName"),
      accessor: "licenseClientName",
      headerStyle: { whiteSpace: "unset" },
      style: { whiteSpace: "unset" },
      userRole: [UserRole.ROLE_ADMIN]
    },
    {
      Header: this.props.formatMessage("connection.hostname"),
      accessor: "hostname",
      headerStyle: { whiteSpace: "unset" },
      style: { whiteSpace: "unset" },
      maxWidth: 150,
      userRole: [UserRole.ROLE_ADMIN]
    },
    {
      Header: this.props.formatMessage("connection.plainSystemHardwareId"),
      accessor: "plainSystemHardwareId",
      headerStyle: { whiteSpace: "unset" },
      style: { whiteSpace: "unset" },
      userRole: [UserRole.ROLE_ADMIN]
    },
    {
      Header: this.props.formatMessage("connection.systemHardwareId") + "/" + this.props.formatMessage("connection.licenseSystemHardwareId"),
      accessor: "systemHardwareId",
      headerStyle: { whiteSpace: "unset" },
      style: { whiteSpace: "unset" },
      minWidth: 300,
      maxWidth: 300,
      Cell: row => {
        return (
          <div>
            {row.original.systemHardwareId}
            <br />
            {row.original.licenseSystemHardwareId}
          </div>
        )
      },
      userRole: [UserRole.ROLE_ADMIN]
    },
    /*
    {
      Header: this.props.formatMessage("connection.applicationBuild"),
      accessor: "applicationBuild",
      headerStyle: { whiteSpace: "unset" },
      style: { whiteSpace: "unset" }
    },*/
    {
      Header: this.props.formatMessage("connection.applicationVersion"),
      accessor: "applicationVersion",
      headerStyle: { whiteSpace: "unset" },
      style: { whiteSpace: "unset", textAlign: "right" },
      maxWidth: 80,
      userRole: [UserRole.ROLE_ADMIN, UserRole.ROLE_SERVICE, UserRole.ROLE_MANAGER]
    },
    /*
    {
      Header: this.props.formatMessage("connection.statusDate"),
      id: "statusDate",
      headerStyle: { whiteSpace: "unset" },
      style: { whiteSpace: "unset" },
      maxWidth: 180,
      accessor: data => {
        return formatDateTime(data.statusDate);
      }
    },*/
    {
      Header: this.props.formatMessage("connection.licenseSoftwareExpirationDate"),
      id: "licenseSoftwareExpirationDate",
      headerStyle: { whiteSpace: "unset" },
      style: { whiteSpace: "unset" },
      maxWidth: 100,
      accessor: data => {
        return formatDate(data.licenseSoftwareExpirationDate);
      },
      userRole: [UserRole.ROLE_ADMIN, UserRole.ROLE_SERVICE, UserRole.ROLE_MANAGER]
    },
    {
      Header: this.props.formatMessage("connection.licenseSoftwareExpirationUpdateDate"),
      id: "licenseSoftwareExpirationUpdateDate",
      headerStyle: { whiteSpace: "unset" },
      style: { whiteSpace: "unset" },
      maxWidth: 100,
      accessor: data => {
        return formatDate(data.licenseSoftwareExpirationUpdateDate);
      },
      userRole: [UserRole.ROLE_ADMIN, UserRole.ROLE_SERVICE, UserRole.ROLE_MANAGER]
    },
    {
      Header: this.props.formatMessage("connection.hostAddress") + "/" + this.props.formatMessage("connection.remoteAddress"),
      accessor: "hostAddress",
      headerStyle: { whiteSpace: "unset" },
      style: { whiteSpace: "unset" },
      maxWidth: 160,
      minWidth: 160,
      Cell: row => {
        return (
          <div>
            {row.original.hostAddress}
            <br />
            {row.original.remoteAddress}
          </div>
        )
      },
      userRole: [UserRole.ROLE_ADMIN]
    },
    {
      Header: this.props.formatMessage("connection.updateServiceStatus"),
      accessor: "updateServiceStatus",
      headerStyle: { whiteSpace: "unset" },
      style: { whiteSpace: "unset" },
      minWidth: 100,
      maxWidth: 200,
      userRole: [UserRole.ROLE_ADMIN]
    },
    /* test autoryzacji JWT */
    /*
    {
      Header: "",
      headerStyle: { whiteSpace: "unset" },
      maxWidth: 100,
      Cell: row => {
        return (
          <div>
            <button
              className="w3-btn"
              onClick={() => this.onRowAuthorizationJWT(row.original)}
            >JWT&nbsp;
              <i className="fas fa-cogs"></i>
            </button>
          </div>
        )
      },
      userRole: [UserRole.ROLE_ADMIN]
    },
    */
    /* test autoryzacji HMAC */
    /*
    {
      Header: "",
      headerStyle: { whiteSpace: "unset" },
      maxWidth: 100,
      Cell: row => {
        return (
          <div>
            <button
              className="w3-btn"
              onClick={() => this.onRowAuthorizationHMAC(row.original)}
            >HMAC&nbsp;
              <i className="fas fa-cogs"></i>
            </button>
          </div>
        )
      },
      userRole: [UserRole.ROLE_ADMIN]
    },
    */
    {
      expander: true,
      style: { whiteSpace: "unset", textAlign: "center" },
      width: 30,
      sortable: false,
      filterable: false,
      Expander: ({ isExpanded, ...rest }) => {
        return (
          <div>{isExpanded ? <span className="w3-large w3-text-theme"><i className="fas fa-minus"></i></span> : <span className="w3-large w3-text-theme"><i className="fas fa-plus"></i></span>}</div>
        );
      },
      userRole: [UserRole.ROLE_ADMIN]
    },
    {
      Header: "",
      style: { whiteSpace: "unset", textAlign: "center" },
      minWidth: 30,
      sortable: false,
      filterable: false,
      Cell: row => {
        if (row.original.companyId) {
          //jesli mamy identyfikator restauracji - telnet nam go nie przyśle

          //domyślnie przycisk jest zielony
          //dla restauracji ktore maja niezaplacone platnosc po terminie - czerwony
          //robimy literke ze zdarzenien onClick, zmiast button, ze wzgledu na oszczednosc miejsca
          let paymentColor = this.props.overduePaymentMap.has(row.original.companyId) ? 'w3-text-pink' : 'w3-text-green';
          let paymentText = 'P'
          return (
            <div className={`w3-large ${paymentColor}`} style={{ cursor: 'pointer' }} onClick={() => this.onRowPaymentClick(row.original)}>
              <span>
                <b>{paymentText}</b>
              </span>
            </div>
          );

        } else {
          //jesli nie mamy identyfikatora restauracji - mamy dopiero po paru sekundach jak przyjdzie status z restauracji
          return null;
        }
      },
      userRole: [UserRole.ROLE_ADMIN]
    },
    {
      Header: "",
      style: { whiteSpace: "unset", textAlign: "center" },
      width: 130,
      sortable: false,
      filterable: false,
      Cell: row => {
        if (row.original.companyId) {
          //jesli mamy identyfikator restauracji - telnet nam go nie przyśle

          //domyślnie przycisk jest zielony
          //dla restauracji ktore maja niezaplacone platnosc po terminie - czerwony
          let paymentColor = this.props.overduePaymentMap.has(row.original.companyId) ? 'w3-pink' : 'w3-green';
          let paymentText = 'Płatności'
          return (
            <div>
              <button
                className={`w3-btn ${paymentColor}`}
                onClick={() => this.onRowPaymentClick(row.original)}
              >
                <b>{paymentText}</b>
              </button>
            </div>
          );

        } else {
          //jesli nie mamy identyfikatora restauracji - mamy dopiero po paru sekundach jak przyjdzie status z restauracji
          return null;
        }
      },
      userRole: [UserRole.ROLE_SERVICE, UserRole.ROLE_MANAGER]
    },
    {
      Header: "",
      style: { whiteSpace: "unset", textAlign: "center" },
      width: 130,
      sortable: false,
      filterable: false,
      Cell: row => {
        if (row.original.companyId) {
          //jesli mamy identyfikator restauracji - telnet nam go nie przyśle

          //szukamy typu połączenia bazując na dwoch właściwościach
          let connectionType = getConnectionType(row.original.originalConnection, row.original.currentVersion);
          //sprawdzamy czy jest różne undefined - jest to możliwe jeśli w połączeniu flagi originalConnection/currentVersion są niewypełnione
          // <= 8.3.26 [FLOW-SERVER] 0006540: pierwsze połączenie z flow24 - błąd i brak danych z licencji (az)
          if (connectionType) {
            return (
              <div>
                <button
                  className={`w3-btn ${connectionType.cssStyle}`}
                  onClick={() => this.onRowBOClick(row.original)}
                >
                  {connectionType.boldStyle ? <b>{connectionType.redirectDisplayText}</b> : connectionType.redirectDisplayText}
                </button>
              </div>
            );
          } else {
            return null;
          }

        } else {
          //jesli nie mamy identyfikatora restauracji - mamy dopiero po paru sekundach jak przyjdzie status z restauracji
          return null;
        }
      },
      userRole: [UserRole.ROLE_ADMIN, UserRole.ROLE_SERVICE, UserRole.ROLE_MANAGER]
    }
  ];

  /**
   * Sub Komponent, który pojawia się dla wiersza rozrzerzonego
   * 
   * {@param row} model wiersza w tabelce
   */
  subComponent = (row) => {
    return (
      <div className="w3-theme-l4">
        <div className="w3-panel w3-small">

          <div className="w3-bar-block w3-right">
            <div className="w3-bar-item">
              Połączenie: {row.original.id}
            </div>
            <div className="w3-bar-item">
              Licencja: {row.original.companyId} | {row.original.companyName} | {row.original.companyDescription} | {row.original.hostname}
            </div>
            <div className="w3-bar-item">
              <button
                className="w3-btn w3-theme width200 w3-border w3-border-theme-l4 w3-leftbar"
                onClick={() => this.onRowLicenseClick(row.original)}
              >
                Pobierz licencję
                    </button>
              <button
                className="w3-btn w3-theme width200 w3-border w3-border-theme-l4 w3-leftbar"
                onClick={() => this.onRowUpdateServiceStatusClick(row.original)}
              >
                Status Update-Service
                    </button>
              <button
                className="w3-btn w3-theme width200 w3-border w3-border-theme-l4 w3-leftbar"
                onClick={() => this.onRowUpdateServiceReinstallClick(row.original)}
              >
                Reinstall Update-Service
                    </button>
            </div>
          </div>

        </div>
      </div>
    )
  }

  /**
   * Akcja na zmianę rozszerzalności w tabelce
   * 
   * W stanie komponentu zapamiętujemy aktualnie rozszerzny wiersz.
   * 
   * Może być tylko jeden rozszerzony wiersz na raz.
   */
  onExpandedChange = (newExpanded, index, event, cellInfo) => {
    let newExpandedRows = {}
    let rowIndex = index[0];
    if (newExpanded[rowIndex] === false) {
      //wiersz odznaczony - ustawiamy index na false
      newExpandedRows = {};
    } else {
      //wiersz zaznaczony - ustawiamy index wiersza na true
      newExpandedRows = { [rowIndex]: true };
    }

    this.setState({
      ...this.state,
      expandedRows: newExpandedRows,
    });
  }

  /**
  * TEST autoryzacji HMAC
  * 
  * Akcja na klik edycji wiersza w tabelce - test autoryzacji do uzuskania wizytówki
  */
  onRowAuthorizationHMAC = data => {

    //algorytm hmac
    const ALGORITHM = AuthenticationType.HMAC.type;

    const endpointURL = '/v1/company/card';
    const httpMethod = 'get';

    //preparujemy nagłowki/parametry
    let headerMap = new Map();
    headerMap.set(SIGNED_HEADERS.X_FLOW_DATE, new Date().toISOString());
    headerMap.set(SIGNED_HEADERS.X_FLOW_RID, data.companyId);

    const signature = computeSignature(endpointURL, httpMethod, headerMap, ACCEES_KEY, SECRET_KEY);

    const getCompanyCard = `${PROXY_SERVER}${endpointURL}?${SIGNED_HEADERS.X_FLOW_DATE}=${headerMap.get(SIGNED_HEADERS.X_FLOW_DATE)}&${SIGNED_HEADERS.X_FLOW_RID}=${headerMap.get(SIGNED_HEADERS.X_FLOW_RID)}&x-flow-cid=${data.id}&x-flow-authorization=${ALGORITHM} ${signature}`;
    window.open(getCompanyCard, "_blank"); //to open new page in a new tab

  };

  /**
   * TEST autoryzacji JWT
   * 
   * Akcja na klik edycji wiersza w tabelce - test autoryzacji do uzuskania wizytówki
   */
  onRowAuthorizationJWT = data => {

    if (getAuthenticationType() !== AuthenticationType.JWT) {

      alert('Działa tylko dla autoryzacji głównej JWT\nPotrzebny token JWT w localeStorage');
      return;
    }

    //tokem pobierany ze storage
    let token = getAuthToken();

    //algorytm hmac
    const ALGORITHM = token.tokenType;

    const endpointURL = '/v1/company/card';

    const signature = token.accessToken;

    //preparujemy nagłowki/parametry
    let headerMap = new Map();
    headerMap.set(SIGNED_HEADERS.X_FLOW_DATE, new Date().toISOString());
    headerMap.set(SIGNED_HEADERS.X_FLOW_RID, data.companyId);

    const getCompanyCard = `${PROXY_SERVER}${endpointURL}?${SIGNED_HEADERS.X_FLOW_DATE}=${headerMap.get(SIGNED_HEADERS.X_FLOW_DATE)}&${SIGNED_HEADERS.X_FLOW_RID}=${headerMap.get(SIGNED_HEADERS.X_FLOW_RID)}&x-flow-cid=${data.id}&x-flow-authorization=${ALGORITHM} ${signature}`;
    window.open(getCompanyCard, "_blank"); //to open new page in a new tab

  };

  /**
   * Akcja na klik edycji wiersza w tabelce - uruchomienie BO
   * 
   * DLa uzytkownika SERWIS/MANAGER pojawia sie komunikt ze wersja jest niekompatybilna i nie mozna uruchomic BO
   * 
   */
  onRowBOClick = data => {

    //modal z niekompatybilnoscia
    if (!data.currentVersion) {
      //wersja niekompatybilna - uruchamiamy alert z komunikatem
      alert('Wersja aplikacji FLOW nie jest kompatybilna z flow24.pl\n\nZaktualizuj FLOW w restauracji podczas logowania do BackOffice, aby korzystać z flow24.pl');
    }

    //jesli admin - to i tak uruchamiamy
    if (data.currentVersion || checkUserRole(this.props.authenticatedUser, UserRole.ROLE_ADMIN)) {

      //tokem pobierany ze storage
      let token = getAuthToken();

      //identyfikator polaczenia, jesli polaczenie jest oryginalne, nie podajemy identyfikatora
      let cid = data.id;
      if (data.originalConnection) {
        cid = "";
      }

      //dane dotyczace konkretnego polaczenia
      let connectionInfo = `rid/${data.companyId}/cid/${cid}/tokenType/${
        token.tokenType
        }/accessToken/${token.accessToken}`;

      //link do konkretnego polaczenia
      let backofficeApp = BACKOFFICE_APPLICATION + "/" + connectionInfo;

      window.open(backofficeApp, "_blank"); //to open new page in a new tab

    }

  };

  /**
   * Akcja po kliknięciu na żądanie o przesłanie danych z licencji
   */
  onRowPaymentClick = data => {

    this.setState({
      selectedRow: data
    })

    this.showModal();
  };

  /**
   * Akcja po kliknięciu na żądanie o przesłanie danych z licencji
   */
  onRowLicenseClick = data => {
    this.props.onLicenseRequest(data);
  };

  /**
   * Akcja po kliknięciu na żądanie o przesłanie statusu update-service
   */
  onRowUpdateServiceStatusClick = data => {
    this.props.onServiceUpdateStatusRequest(data);
  };

  /**
   * Akcja po kliknięciu na żądanie o reinstalację usługi update-service
   */
  onRowUpdateServiceReinstallClick = data => {
    this.props.onServiceUpdateReinstallRequest(data);
  };

  /**
   * czy uzytkownik ma widok administratora połączeń
   */
  isAdminConnections = checkUserActivity(this.props.authenticatedUser, Activity.LIST_ADMIN_CONNECTIONS);

  /**
   * role zalogowanego uzytkownika, moze miec wiecej jak jedna
   */
  userRoles = getUserRoles(this.props.authenticatedUser);

  /**
   * kolumny filtrujemy w zaleznosci od posiadanych rol
   */
  filteredTableColumns = this.tableColumns.filter(tableColumn => { return tableColumn.userRole.some(tableColumnRole => this.userRoles.includes(tableColumnRole)) });

  /**
  * Admin ma filtr wiec wiersze w tabelce opieraja sie na wyfiltrowanych danych
  * 
  * Pozostali nie maja filtru, wiec dane sa zwracane w takiej postaci jak przyjda z serwera
  * 
  */
  render() {

    const { formatMessage } = this.props;

    return (
      <div className="">

        {/*Admin widzi połączenia*/}
        {this.isAdminConnections && <PageHeader text="app.connectionPage.title" />}

        {/*Pozostali widzą restauracje*/}
        {!this.isAdminConnections && <PageHeader text="app.restaurantPage.title" />}

        {/*Admin widzi filtr połączeń*/}
        {this.isAdminConnections && <ConnectionFilter />}

        {/*Admin widzi inne kolumny w tabelce + ma opcje rozszerzania wiersza*/}
        {this.isAdminConnections && <FlowTable
          data={this.props.filteredConnectionList}
          columns={this.filteredTableColumns}
          loading={false}
          SubComponent={this.subComponent}
          onExpandedChange={this.onExpandedChange}
          expanded={this.state.expandedRows}

        />}

        {/*Pozostali widzą prostą tabelkę*/}
        {!this.isAdminConnections && <FlowTable
          data={this.props.connectionList}
          columns={this.filteredTableColumns}
          loading={false}
        />}

        <Modal ref={"modal"} modalStyle={modalStyle} backdropStyle={backdropStyle} contentStyle={contentStyle}>
          <RestaurantPayments companyId={this.state.selectedRow.companyId} companyName={this.state.selectedRow.companyName} onClose={this.hideModal} formatMessage={formatMessage} />
        </Modal>

      </div>
    );
  }
}

Connections.propTypes = {
  formatMessage: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  connectionList: state.connectionReducer.connectionList,
  filteredConnectionList: state.connectionReducer.filteredConnectionList,
  authenticatedUser: state.authReducer.authenticatedUser,
  overduePaymentMap: state.paymentReducer.overduePaymentMap
});

const mapDispatchToProps = dispatch => {
  return {
    onFetch: callback => {
      dispatch(connectionActions.fetchConnections(callback));
    },
    onFetchGlobalParams: callback => {
      dispatch(globalParamAction.fetchGlobalParams(callback));
    },
    onFetchOverduePayments: callback => {
      dispatch(paymentAction.fetchOverduePayments(callback));
    },
    onLicenseRequest: connection => {
      dispatch(connectionActions.licenseRequest(connection.id));
    },
    onServiceUpdateStatusRequest: connection => {
      dispatch(connectionActions.updateServiceStatusRequest(connection.id));
    },
    onServiceUpdateReinstallRequest: connection => {
      dispatch(connectionActions.updateServiceReinstallRequest(connection.id));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Connections);
